import { CheckCircleFilled } from '@ant-design/icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUtensils } from '@fortawesome/free-solid-svg-icons';
import './MealItem.less';

const MealItem = ({ meal, isSelected, onClick, customizations: mealOptions = [] }) => {
	return (
		<div>
			<div
				className={`meal-item ${isSelected ? 'selected' : ''} ${meal.soldOut ? 'sold-out' : ''}`}
				onClick={onClick}
			>
				<div className="meal-image-container">
					{meal.image ? (
						<img
							src={meal.image}
							alt={meal.name}
							className="meal-image"
						/>
					) : (
						<div className="meal-image-placeholder meal-icon-placeholder">
							<FontAwesomeIcon
								icon={faUtensils}
								className="meal-placeholder-icon"
							/>
						</div>
					)}
					{meal.soldOut && (
						<div className="sold-out-overlay">
							<span className="sold-out-badge">SOLD OUT</span>
						</div>
					)}
					{isSelected && !meal.soldOut && (
						<div className="selected-indicator">
							<CheckCircleFilled className="selected-check-icon" />
						</div>
					)}
				</div>
				<div className="meal-details">
					<div className="meal-info">
						<h3 className="meal-name">{meal.name}</h3>
						<p className="meal-description">{meal.description}</p>
						<p className="meal-price">${meal.price.toFixed(2)}</p>
					</div>
				</div>
			</div>
		</div>
	);
};

export default MealItem;
